/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Slots_InvalidInputs */

const en_interview_slots_invalid = /** @type {(inputs: Interview_Slots_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid appointment: start and end must be valid and the end must be after the start.`)
};

const de_interview_slots_invalid = /** @type {(inputs: Interview_Slots_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiger Termin: Start und Ende müssen gültig sein und das Ende muss nach dem Start liegen.`)
};

/**
* | output |
* | --- |
* | "Invalid appointment: start and end must be valid and the end must be after the start." |
*
* @param {Interview_Slots_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const interview_slots_invalid = /** @type {((inputs?: Interview_Slots_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Slots_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_slots_invalid(inputs)
	return en_interview_slots_invalid(inputs)
});